(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const flickityElement = document.querySelector('.js-flickity');
  if (!flickityElement) return;

  // breakpoint: >=768px = desktop (ajusta si quieres otro)
  const mql = window.matchMedia('(min-width: 768px)');

  function getGroupCells() {
    return mql.matches ? 1 : 1;
  }

  let flickityInstance = null;

  function createFlickity() {
    if (flickityInstance) {
      try { flickityInstance.destroy(); } catch (e) { /* ignore */ }
      flickityInstance = null;
    }

    flickityInstance = new Flickity(flickityElement, {
      groupCells: getGroupCells(),
      pageDots: false,
    });

  }

  createFlickity();

  window.addEventListener('load', function () {
    const expected = getGroupCells();
    if (!flickityInstance || flickityInstance.options.groupCells !== expected) {
      createFlickity();
    } else {
      flickityInstance.resize();
    }
  });

  function onMqChange(e) {
    const newGroup = e.matches ? 1 : 1;
    if (flickityInstance && flickityInstance.options.groupCells === newGroup) {
      return;
    }
    createFlickity();
  }
  if (mql.addEventListener) mql.addEventListener('change', onMqChange);
  else if (mql.addListener) mql.addListener(onMqChange); // compatibilidad

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const expected = getGroupCells();
      if (!flickityInstance || flickityInstance.options.groupCells !== expected) {
        createFlickity();
      } else if (flickityInstance) {
        flickityInstance.resize();
      }
    }, 150);
  });

  window.addEventListener('orientationchange', function () {
    setTimeout(function () { // pequeño delay para que cambie el viewport
      const expected = getGroupCells();
      if (!flickityInstance || flickityInstance.options.groupCells !== expected) {
        createFlickity();
      } else if (flickityInstance) {
        flickityInstance.resize();
      }
    }, 120);
  });

  document.querySelectorAll('.stl-hotspot').forEach(hotspot => {
    hotspot.addEventListener('click', () => {
      const index = parseInt(hotspot.getAttribute('data-index'), 10);
      if (!isNaN(index) && flickityInstance) flickityInstance.select(index);
    });
  });
});



// document.addEventListener("DOMContentLoaded", function () {
//   var flickityElement = document.querySelector('.js-flickity');
//   var flickityInstance = new Flickity(flickityElement, {
//     groupCells: 2,
//     pageDots: false
//   });

//   document.querySelectorAll('.stl-hotspot').forEach(hotspot => {
//     hotspot.addEventListener('click', () => {
//       const index = parseInt(hotspot.getAttribute('data-index'));
//       flickityInstance.select(index);
//     });
//   });
// });

  } catch(e) { console.error(e); }
})();
})();
